import React, { useState } from "react";
import "./css/FAQs.scss";

// Components

import Accordion from "../components/Accordion";
import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";

const FAQ = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  return (
    <div
      className='faqs-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"FAQs"} />
      <div className='faqs-selection'>
        <div className='inner-container'>
          <div id='containerFAQs'>
            <Accordion
              title='What is Getwell Health Systems Inc.?'
              content='Getwell Health Systems, Inc. is a Health Maintainance Organization ( HMO ) a company that offers managed health care services for its members through their accredited physicians, hospitals and clinics.'
            />
            <Accordion
              title='Who are qualified to be Getwell members?'
              content='Membership is open to all private companies, e.g. manpower agency, security agency, or cooperatives having at least 100 employees, whether regular or contractual. Age requirement is 18 – 60 years old.'
            />
            <Accordion
              title='How is membership being paid?'
              content='Payment is through salary deduction.'
            />
            <Accordion
              title='What are the services rendered by Getwell to its members?'
              content='The Health Benefits of Getwell are the following: Preventative Healthcare, Out-patient Consultation, In-patient/Hospital Confinement, Emergency Treatment, Dental Services, Accident Insurance Coverage ( Optional ), and Financial Assistance.'
            />
            <Accordion
              title='If I’ll be interested to enroll my company to Getwell, what are the requirements needed?'
              content='You must first agree with Getwell on the package you want to give to your employees. Then, both parties can proceed for contract signing. Submit the list of employees to be enrolled ( with complete information: full name, birthdates, address, name of beneficiary, and his/her position in the company.) After 3 days, you will receive your billing.'
            />
            <Accordion
              title='Can I continue my membership when i resigned with my employer?'
              content={`No, We don't cater individual membership, only to corporate account.`}
            />
            <Accordion
              title='Can my family use my Getwell card?'
              content='No, Getwell is non-transferable, only the principal member can use the card.'
            />
            <Accordion
              title='Can I refund my payments if I decided to discontinue my membership?'
              content='Non-Refundable.'
            />
            <Accordion
              title={`I'm a cooperative member, can we enroll at Getwell?`}
              content='Yes, as long as you meet the required requirement of 100 members as initial enrollment.'
            />
            <Accordion
              title='I am a factory worker, as we know, our job is hazardous, does Getwell equip with such benefits?'
              content='Yes, we incorporate accidental benefits for our members.'
            />
          </div>
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default FAQ;
